import {
    FETCH_REFUND_REQUEST,
    FETCH_REFUND_SUCCESS,
    FETCH_REFUND_ERROR,
    HIDE_REFUND_LOADER,
    SHOW_REFUND_LOADER,
    INITIATE_REFUND_REQUEST,
    INITIATE_REFUND_SUCCESS,
    INITIATE_REFUND_ERROR,
} from './refund.constants';

export const fetchRefundRequest = payload => ({
    type: FETCH_REFUND_REQUEST,
    payload,
});

export const fetchRefundSuccess = payload => ({
    type: FETCH_REFUND_SUCCESS,
    payload,
});

export const fetchRefundError = payload => ({
    type: FETCH_REFUND_ERROR,
    payload,
});

export const initiateRefundRequest = payload => ({
    type: INITIATE_REFUND_REQUEST,
    payload,
});

export const initiateRefundSuccess = payload => ({
    type: INITIATE_REFUND_SUCCESS,
    payload,
});

export const initiateRefundError = payload => ({
    type: INITIATE_REFUND_ERROR,
    payload,
});

export const showLoader = () => ({ type: SHOW_REFUND_LOADER });

export const hideLoader = () => ({ type: HIDE_REFUND_LOADER });
